export const initialValueScaleZoomDesktop = 1;
export const initialValueScaleZoomMobile = 0.5;